<template>
  <div class="row">
    <div class="col-md-10">
      <input type="text" class="form-control" v-model="searchTerm"
             :placeholder="'Pesquisar ' + entityLabelLower">
    </div>
    <div class="col-md-2">
      <button type="button" class="btn btn-primary" @click="openModalStore()">
        Novo {{ entityLabel }}
      </button>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
      <tr>
        <th>{{ entityLabel }}</th>
        <th>Valor</th>
        <th>Ativo?</th>
        <th>Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="exam in examsItems.data" :key="exam.id_item">
        <td>
          {{ itemLabel(exam) }}
          <div v-if="isCheckupTab" class="text-muted fs-7">
            <span v-if="(exam.package_items ?? []).length">
              {{ exam.package_items.length }} itens ·
              soma {{ formatMoney(sumItems(exam.package_items)) }}
            </span>
            <span v-else>Sem itens no pacote</span>
          </div>
        </td>
        <td>R$ {{ Number(exam.active_value?.item_value ?? 0).toFixed(2) }}</td>
        <td>{{ exam.item_active ? 'Sim' : 'Não' }}</td>
        <td>
          <button class="btn btn-sm btn-outline btn-outline-secondary me-5" @click="openModalEdit(exam)">
            <i class="bi bi-pencil"></i>
          </button>
          <button class="btn btn-sm btn-outline btn-outline-secondary me-5" @click="deleteExam(exam.id_item)">
            <i class="bi bi-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>

    <Pagination :data="exams"/>

    <div class="modal fade" tabindex="-1" :id="'modal_exam_lab_occup_'+type">
      <div class="modal-dialog modal-xl">
        <form @submit.prevent="submitExam">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ formExam.id_spec ? 'Editar' : 'Novo' }} Exame
              </h5>

              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                   aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-8" v-if="usesFreeName">
                  <label class="required form-label">Nome do {{ entityLabelLower }}</label>
                  <input type="text" required class="form-control form-control-solid"
                         v-model="formExam.item_name"
                         :placeholder="'Nome do ' + entityLabelLower">
                </div>
                <div class="col-md-8" v-else>
                  <label class="required form-label">{{ entityLabel }}</label>
                  <Dropdown :options="exams"
                            :filter="true"
                            :filterFields="['exam_tuss_code', 'exam_name']"
                            appendTo="self" showClear
                            v-model="formExam.id_exam"
                            :virtualScrollerOptions="{ itemSize: 38 }"
                            :optionLabel="(e) => e.exam_tuss_code + ' - ' + e.exam_name"
                            optionValue="id_exam"
                            id="exam_id_exam"
                            empty-message="Nenhuma opção"
                            empty-filter-message="Nenhuma opção encontrada"
                            class="form-control form-control-solid w-full md:w-14rem"
                            :placeholder="'Selecione um ' + entityLabelLower"
                            style="display: flex; padding: 0.25rem .75rem">
                    <template #option="slotProps">
                      <div class="flex align-items-center text-truncate" style="max-width: 350px;">
                        <div>
                          {{ slotProps.option.exam_tuss_code }} - {{ slotProps.option.exam_name }}
                        </div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
                <div class="col-md-4">
                  <label class="required form-label">Valor</label>
                  <money3 required
                          class="form-control form-control-solid"
                          v-model="formExam.active_value.item_value"
                          v-bind="config">
                  </money3>
                </div>
                <div class="col-md-12" v-if="isCheckupTab">
                  <label class="form-label">Itens do check-up</label>
                  <MultiSelect v-model="formExam.items"
                               :options="packageCandidates"
                               :filter="true"
                               :filterFields="['item_label']"
                               optionLabel="item_label"
                               optionValue="id_item"
                               display="chip"
                               appendTo="self"
                               empty-message="Nenhum item cadastrado"
                               empty-filter-message="Nenhum item encontrado"
                               class="form-control form-control-solid w-full"
                               placeholder="Escolha os itens que compõem o check-up"
                               style="display: flex; padding: 0.25rem .75rem" />
                  <div class="form-text">
                    Soma dos itens: <strong>{{ formatMoney(packageTotal) }}</strong>
                    <span v-if="packageDiscount > 0" class="text-success ms-2">
                      pacote {{ formatMoney(packageDiscount) }} mais barato
                    </span>
                    <span v-else-if="packageDiscount < 0" class="text-warning ms-2">
                      pacote {{ formatMoney(-packageDiscount) }} acima da soma
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <label for="item_obs" class="form-label">Preparo</label>
                  <textarea class="form-control form-control-solid" :placeholder="'Preparo do ' + entityLabelLower"
                            id="item_obs" v-model="formExam.item_obs"></textarea>
                </div>
                <div class="col-md-8">
                  <br>
                  <div class="mb-3">
                    <label class="form-check-label" for="item_active">
                      Ativar {{ entityLabelLower }}?
                    </label>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" v-model="formExam.item_active"
                             role="switch" id="item_active">

                      <label class="form-check-label">
                        {{ formExam.item_active ? 'Sim' : 'Não' }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
              <button type="submit" class="btn btn-primary">Salvar</button>
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import Modal from "@/helpers/modal";
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Pagination from "@/components/Pagination.vue";
import {Money3} from "v-money3";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";

export default {
  name: "TabExamLabAndOccup",
  props: ['exams', 'type'],
  components: {
    Money3,
    Pagination,
    Dropdown,
    MultiSelect,
  },
  data() {
    return {
      searchTerm: '',
      examsItems: [],
      packageCandidates: [],
      config: {
        masked: false,
        prefix: 'R$ ',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 2,
        disableNegative: true,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: false,
        focusOnRight: false,
      },
      formExam: {
        id_exam: null,
        id_place_owner: null,
        item_active: true,
        item_description: null,
        item_obs: null,
        item_type: this.type,
        item_require_sched: false,
        active_value: {
          item_value: 0,
          id_place: null,
          item_base_date: new Date(),
        }
      },
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isProceduresTab() {
      return this.type === 'PROCEDURES';
    },
    entityLabel() {
      return this.labels.singular;
    },
    entityLabelLower() {
      return this.labels.singular.toLowerCase();
    },
    entityLabelPlural() {
      return this.labels.plural.toLowerCase();
    },
    usesFreeName() {
      return ['VACCINE', 'CHECKUP', 'DENTIST'].includes(this.type);
    },
    isCheckupTab() {
      return this.type === 'CHECKUP';
    },
    packageTotal() {
      const chosen = this.formExam.items || [];

      return this.packageCandidates
        .filter(item => chosen.includes(item.id_item))
        .reduce((sum, item) => sum + Number(item.active_value?.item_value ?? 0), 0);
    },
    packageDiscount() {
      return this.packageTotal - Number(this.formExam.active_value?.item_value ?? 0);
    },
    labels() {
      // Os tipos vêm de /budgets/types, então a aba serve para qualquer um.
      switch (this.type) {
        case 'PROCEDURES':
        case 'PROCEDURE':
          return {singular: 'Procedimento', plural: 'Procedimentos'};
        case 'VACCINE':
          return {singular: 'Vacina', plural: 'Vacinas'};
        case 'CHECKUP':
          return {singular: 'Check-up', plural: 'Check-ups'};
        case 'DENTIST':
          return {singular: 'Item de Dentista', plural: 'Itens de Dentista'};
        default:
          return {singular: 'Exame', plural: 'Exames'};
      }
    },
  },
  mounted() {
    this.loadExamItems();
    if (this.isCheckupTab) {
      this.loadPackageCandidates();
    }
  },
  methods: {
    loadPackageCandidates() {
      // Um check-up é composto por itens do próprio local, nunca por outro
      // check-up.
      const types = ['EXAM-LAB', 'EXAM-OCC', 'VACCINE', 'PROCEDURE'];

      Promise.all(
        types.map(type => http.get(`/places/${this.place.id_place}/items`, {
          params: {item_type: type, per_page: 200},
        }))
      ).then(responses => {
        this.packageCandidates = responses
          .flatMap(response => response.data?.data ?? [])
          .map(item => ({
            ...item,
            item_label: item.item_name
              ?? [item.exam?.exam_tuss_code, item.exam?.exam_name].filter(Boolean).join(' - '),
          }))
          .sort((a, b) => (a.item_label ?? '').localeCompare(b.item_label ?? ''));
      });
    },
    itemLabel(item) {
      // Vacina e check-up têm nome livre; exame vem do catálogo TUSS.
      if (item.item_name) {
        return item.item_name;
      }

      return [item.exam?.exam_name, item.exam?.exam_tuss_code]
        .filter(Boolean)
        .join(' - ') || 'Item';
    },
    sumItems(items) {
      return (items ?? []).reduce(
        (sum, item) => sum + Number(item.active_value?.item_value ?? 0),
        0
      );
    },
    formatMoney(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(Number(value ?? 0));
    },
    openModalStore() {
      this.resetForm();
      Modal.toggle('#modal_exam_lab_occup_' + this.type);
    },
    resetForm() {
      this.formExam = {
        id_exam: null,
        id_place_owner: null,
        item_name: null,
        item_active: true,
        item_description: null,
        item_obs: null,
        item_type: this.type,
        item_require_sched: false,
        items: [],
        active_value: {
          item_value: 0,
          id_place: null,
          item_base_date: new Date(),
        }
      };
    },
    openModalEdit(exam) {
      if (this.isCheckupTab) {
        this.loadPackageCandidates();
      }

      this.formExam = {
        id_item: exam.id_item,
        id_exam: exam.id_exam,
        id_place_owner: exam.id_place_owner,
        item_name: exam.item_name,
        items: (exam.package_items ?? []).map(item => item.id_item),
        item_active: exam.item_active,
        item_description: exam.item_description,
        item_obs: exam.item_obs,
        item_type: exam.item_type,
        item_require_sched: exam.item_require_sched,
        active_value: {
          item_value: exam.active_value?.item_value,
        }
      };

      Modal.toggle('#modal_exam_lab_occup_' + this.type);
    },
    loadExamItems() {
      http.get(`/places/${this.place.id_place}/items?item_type=${this.type}`)
        .then(response => {
          this.examsItems = response.data;
        })
        .catch(error => {
          console.error('Erro ao carregar ' + this.entityLabelPlural + ':', error);
          Alert.error('Erro ao carregar ' + this.entityLabelPlural + '. Tente novamente mais tarde.');
        });
    },
    submitExam() {
      this.formExam.id_place_owner = this.place.id_place;

      if (this.formExam.id_item) {
        this.updateExam();
      } else {
        this.storeExam();
      }
    },
    storeExam() {
      http.post(`/places/${this.place.id_place}/items`, this.formExam)
        .then(_ => {
          this.resetForm();
          this.loadExamItems();
          Alert.success(this.entityLabel + ' cadastrado com sucesso!');
          Modal.toggle('#modal_exam_lab_occup_' + this.type);
        })
        .catch(error => {
          console.error('Erro ao cadastrar ' + this.entityLabelLower + ':', error);
          Alert.error('Erro ao cadastrar ' + this.entityLabelLower + '. Tente novamente mais tarde.');
        });
    },
    updateExam() {
      http.put(`/places/${this.place.id_place}/items/${this.formExam.id_item}`, this.formExam)
        .then(_ => {
          this.resetForm();
          this.loadExamItems();
          Alert.success(this.entityLabel + ' atualizado com sucesso!');
          Modal.toggle('#modal_exam_lab_occup_' + this.type);
        })
        .catch(error => {
          console.error('Erro ao atualizar ' + this.entityLabelLower + ':', error);
          Alert.error('Erro ao atualizar ' + this.entityLabelLower + '. Tente novamente mais tarde.');
        });
    },
    deleteExam(id) {
      Swal.fire({
        title: 'Heeyy',
        text: `Tem certeza que deseja remover o ${this.entityLabelLower}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/items/${id}`)
            .then(() => {
              this.loadExamItems();
              Alert.success(this.entityLabel + ' excluído com sucesso!');
            })
            .catch(error => {
              console.error('Erro ao excluir ' + this.entityLabelLower + ':', error);
              Alert.error('Erro ao excluir ' + this.entityLabelLower + '. Tente novamente mais tarde.');
            });
        }
      });
    }
  },
}
</script>

<style scoped>

</style>